/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Min_Cps_LabelInputs */



/**
* | output |
* | --- |
* | "Minimum Characters Per Second (CPS)" |
*
* @param {Style_Guide_Manager_Min_Cps_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_min_cps_label = /** @type {((inputs?: Style_Guide_Manager_Min_Cps_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Min_Cps_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Caracteres minimum par seconde (CPS)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestanzahl an Zeichen pro Sekunde (CPS)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero minimo di caratteri al secondo (CPS)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальное количество символов в секунду (CPS)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mínimo de caracteres por segundo (CPS)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每秒最低字符数 (CPS)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1秒あたりの最小文字数（CPS）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("न्यूनतम वर्ण प्रति सेकंड (सीपीएस)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Caracteres mínimos por segundo (CPS)")
	return /** @type {LocalizedString} */ ("Minimum Characters Per Second (CPS)")
});